import cytoscape from 'cytoscape';
import klay from 'cytoscape-klay';
cytoscape.use(klay);


const applyKlayLayout = (nodes, edges, isHorizontal = false) => {

    // Create an in-memory Cytoscape instance
    const cy = cytoscape({
        headless: true, // no UI, perform layout in memory
        styleEnabled: false,
        elements: []
    });

    // Add nodes
    nodes.forEach((node) => {
        cy.add({
            group: 'nodes',
            data: {
                id: node.properties.topicId,
                ...node.properties,
            },
        });
    });

    // Add edges
    edges.forEach((edge, index) => {
        cy.add({
            group: 'edges',
            data: {
                source: edge.start,
                target: edge.end
            }
        });
    });

    // Configure Klay layout
    // Adjust these parameters as needed to control spacing, direction, etc.
    const layoutDirection = isHorizontal ? 'RIGHT' : 'UP';
    const klayLayoutOptions = {
        name: 'klay',
        nodeDimensionsIncludeLabels: false,
        fit: false,
        klay: {
            direction: 'UP',
            spacing: 120,
            edgeSpacingFactor: 0.0,  // try zero so edges don't influence spacing
            //nodePlacement: 'LINEAR_SEGMENTS', 
            compactComponents: true,
            inLayerSpacingFactor: 2.5,
            fixedAlignment: 'BALANCED',
            layoutHierarchy: true,
            thoroughness: 21,
        }
    };

    // Run the layout
    cy.layout(klayLayoutOptions).run();

    const nodeWidth = 200;
    const nodeHeight = 70;
    const gridWidth = 120; // set 20 for natural gap size between nodes, but cause overlapping of edges and nodes
    const gridHeight = 140;

    const snapToGrid = (value, gridSize) => {
        return Math.floor(value / gridSize) * gridSize;
        //return Math.round(value / gridSize) * gridSize;
    };

    // Extract positions from Klay
    const layoutNodes = cy.nodes().map((n) => ({
        ...n.data(),
        x: n.position('x'),
        y: n.position('y')
    }));

    cy.destroy();

    // Sort nodes by their Klay-assigned Y to identify layers
    layoutNodes.sort((a, b) => a.y - b.y);

    // Determine layers by grouping nodes in ascending y. Instead of using the exact Klay positions,
    // we just care about their relative order. Assign each unique vertical "band" as a layer.
    const layerSpacing = 200;  // fixed vertical spacing between layers
    const layers = [];
    let currentLayerNodes = [];
    let prevY = layoutNodes[0].y;

    const verticalThreshold = 100;
    // verticalThreshold: If nodes differ by more than a certain amount in Y, consider that a new layer.

    layoutNodes.forEach(node => {
        if (Math.abs(node.y - prevY) > verticalThreshold && currentLayerNodes.length > 0) {
            layers.push(currentLayerNodes);
            currentLayerNodes = [];
        }
        currentLayerNodes.push(node);
        prevY = node.y;
    });
    if (currentLayerNodes.length > 0) {
        layers.push(currentLayerNodes);
    }

    // Now we have layers[] with each sub-array = nodes in that layer.
    // Assign uniform y: first layer at 0, second at layerSpacing, etc.
    layers.forEach((layer, layerIndex) => {
        const baseY = layerIndex * layerSpacing;
        // Sort nodes in this layer by their x to place them horizontally
        layer.sort((a, b) => a.x - b.x);

        // Determine if this is an even layer (0-based)
        //const isEvenLayer = layerIndex % 2 === 0;

        // Position nodes
        layer.forEach(node => {
            let gridX = snapToGrid(node.x, gridWidth);
            let gridY = baseY; // uniform vertical spacing

            //if (isEvenLayer) {
            //    gridX += gridWidth / 2;
            //}

            node.x = gridX;
            node.y = gridY;
        });
    });

    // Flatten layers back into updated nodes array
    const updatedNodes = layers.flat();

    // Center edge to node's center
    const updatedEdges = edges.map(edge => {
        const sourceNode = updatedNodes.find(n => n.topicId === edge.start);
        const targetNode = updatedNodes.find(n => n.topicId === edge.end);

        const x1 = sourceNode.x + nodeWidth / 2;
        const y1 = sourceNode.y + nodeHeight / 2;
        const x2 = targetNode.x + nodeWidth / 2;
        const y2 = targetNode.y + nodeHeight / 2;

        return {
            ...edge,
            x1,
            y1,
            x2,
            y2,
        };
    });

    return { updatedNodes, updatedEdges };
};

export default applyKlayLayout;